<button class="ProfileSheet profile" mat-fab type="button" [class.border]="!src" [matMenuTriggerFor]="menu">
  <img *ngIf="src"
       class="ProfilSheet-img"
       src="{{ src }}"
       alt="{{ 'ME.ALT_USER_PICTURE' | translate }}"
       (error)="onError()">
  <mat-icon class="ProfileSheet-icon" *ngIf="!src" svgIcon="sprite:account"></mat-icon>
</button>
<mat-menu class="custom profile" #menu="matMenu">
  <ng-container>
    <div class="ProfileSheet-header">
      <div class="ProfileSheet-header--picture">
        <def-profil-picture size="66" [disabled]="true"></def-profil-picture>
      </div>
      <div class="ProfileSheet-header--info">
        <p class="ProfileSheet-header--info-name">{{ userFullName }}</p>
        <p class="ProfileSheet-header--info-job">{{ userTitles }}</p>
      </div>
    </div>
  </ng-container>
</mat-menu>
